import { defineComponent as _defineComponent } from 'vue'
import icons, { Icons } from '@/views/Automation/CampaignCreatorV2/helpers/icons';
import { isDefined } from '@sh/helpers';
import { computed } from 'vue';

interface Props {
  type: Icons;
  height?: number;
  fill?: boolean;
  styles?: Record<string, string>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcIcon.ts',
  props: {
    type: null,
    height: null,
    fill: { type: Boolean },
    styles: null
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  type: Icons;
  height?: number;
  fill?: boolean;
  styles?: Record<string, string>;
};





const icon = computed(() => icons[props.type]);

const style = computed(() => ({
  ...(isDefined(props.height) && { height: `${props.height}px` }),
  ...(isDefined(props.height) && { width: `${props.height}px` }),
  ...(props.styles && { ...props.styles }),
}));

return { __sfc: true,emits, props, icon, style }
}

})